export const unitOfUseOptions = [
    { key: "day", value: "ต่อวัน", text: "ต่อวัน" },
    { key: "week", value: "ต่อสัปดาห์", text: "ต่อสัปดาห์" },
    { key: "month", value: "ต่อเดือน", text: "ต่อเดือน" },
  ];
  
  export const warrantyOptions = [
    { key: "0", value: 0, text: "ไม่อยู่ในการรับประกัน" },
    { key: "1", value: 1, text: "อยู่ในการรับประกัน" },
    { key: "2", value: 2, text: "" },
  ];

  export const warrantyYOptions = [
    { key: "0", value: 356, text: "1 ปี" },
    { key: "1", value: 730, text: "2 ปี" },
    // { key: "1", value: 1095, text: "3 ปี" },
  ];
  
  export const contactOptions = [
    { key: "on_site", value: "on_site", text: "ผ่าน Line" },
    { key: "mobile", value: "mobile", text: "ผ่านโทรศัพท์" },
    { key: "seller_team", value: "seller_team", text: "ผ่านฝ่ายขาย" },
    { key: "sevice_team", value: "sevice_team", text: "ผ่านทาง Service team" },
  ];
  
  export const stateOptions = [
    { key: "contacted", value: "contacted", text: "แจ้งซ่อมแล้ว" },
    { key: "draft", value: "draft", text: "แจ้งลูกค้าเรียบร้อย" },
    {
      key: "contact_fail",
      value: "contact_fail",
      text: "ติดต่อลูกค้าไม่ได้",
    },
    { key: "later", value: "later", text: "ติดต่ออีกครั้งวันที่" },
  ];
  
  export const problemOptions = [
    {
      key: "device",
      value: "ปัญหาเกี่ยวกับเครื่องจักร",
      text: "ปัญหาเกี่ยวกับเครื่องจักร",
    },
    {
      key: "parts",
      value: "ปัญหาเกี่ยวกับอะไหล่",
      text: "ปัญหาเกี่ยวกับอะไหล่",
    },
    {
      key: "process",
      value: "ปัญหาเกี่ยวกับการใช้งาน",
      text: "ปัญหาเกี่ยวกับการใช้งาน",
    },
    { key: "other", value: "ปัญหาอื่นๆ", text: "ปัญหาอื่นๆ" },
  ];
  